import script from "./MapFigure.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapFigure.vue?vue&type=script&setup=true&lang=ts"

import "./MapFigure.vue?vue&type=style&index=0&id=25e9d8cb&lang=less"

const __exports__ = script;

export default __exports__